// utils/stripePromise.js
import { loadStripe } from '@stripe/stripe-js';

export const stripeAUDPromise = loadStripe('pk_live_51HKCkSD75ny8E7UiLn5Vj0f3UW0qwQYEFYXW0HiOWh8hUtw0c2ZwYkC3dr5uN9IzrFrNCbe97j7NUWJCIitFkeae00riWtMndI'); // AUD
/* -------------------------------------------------------------------------- */

/* ----------------------------- New Production key --------------------- */
export const stripeUKPromise = loadStripe('pk_live_51O25i3EpTLP297fAAuxdDPYNX04EtyEqgVKa0Wxl7bdAG1elEa0Gr6kbOKsw1ntgCUX4bkSWKv7m5cF4GZ6POGM600TRvCpUVI'); // Other Currencies
/* -------------------------------------------------------------------------- */

/* ----------------------------- USD Production key ------------------------- */
export const stripeUSDPromise = loadStripe('pk_live_51OUajUBZAMFfbiuoVI4AkoXs29h1Y1cumm2neQQfSl4NgMrZOs3LoqkEcGkfrHNRjpY3BWxTdvZwqIg0uDdQxsGE008wra77T1'); // USD
/* -------------------------------------------------------------------------- */